export const SHOW_HOME_MAP_VIEW_ACTION = 'SHOW_HOME_MAP_VIEW';
export const SUPPORTED_ACTIONS = [
  'CHANGE_DELIVERY_TIME',
  'SHOW_MEAL_CARD_ISSUERS',
  'CLEAR_FILTERS',
  'NO_DELIVERY_YET',
  'SHOWCASE_PICKUP',
  SHOW_HOME_MAP_VIEW_ACTION,
];
export const SUPPORTED_BLOCKS = ['BANNER', 'RESTAURANT', 'CARD', 'SHORTCUT'];
export const SUPPORTED_CONTROLS = ['APPLIED_FILTER', 'FILTER', 'SORT'];
export const SUPPORTED_FEATURES = ['UNAVAILABLE_RESTAURANTS', 'HOME_MAP_VIEW'];
export const SUPPORTED_LAYOUTS = ['LIST', 'CAROUSEL'];
export const SUPPORTED_TARGETS = ['PARAMS', 'RESTAURANT', 'MENU_ITEM'];
export const SUPPORTED_THEMES = [
  'BANNER_EMPTY',
  'BANNER_MARKETING_A',
  'BANNER_MARKETING_B',
  'BANNER_MARKETING_C',
  'BANNER_PICKUP_SHOWCASE',
  'BANNER_SERVICE_ADVISORY',
  'CARD_LARGE',
  'CARD_MEDIUM',
  'CARD_SMALL',
  'CARD_WIDE',
  'RESTAURANT_LARGE',
  'RESTAURANT_MEDIUM',
  'RESTAURANT_SMALL',
  'SHORTCUT_DEFAULT',
];
